import React from 'react';
import { Link } from 'react-router-dom';
import './mainVisual.css';

const MainVisual = () => {
    const features = [
        {
            number: '01',
            icon: 'mdi-lightbulb-outline',
            title: '맞춤 솔루션 제공',
            description: '공간과 목적에 최적화된 설계'
        },
        {
            number: '02',
            icon: 'mdi-tools',
            title: '전문 시공 인력',
            description: '풍부한 경험의 전문 엔지니어'
        },
        {
            number: '03',
            icon: 'mdi-shield-check-outline',
            title: '철저한 사후관리',
            description: '설치 이후 유지보수까지 책임지는 체계적인 관리'
        },
        {
            number: '04',
            icon: 'mdi-office-building-outline',
            title: '다양한 설치 경험',
            description: '학교, 교회, 기업, 관공사 등 다양한 분야의 시공 경험'
        }
    ];

    return (
        <div className="main-visual">
            <div className="main-visual-overlay"></div>
            <div className="main-visual-inner">
                <div className="main-visual-content">
                    <p className="main-visual-eyebrow">
                        LED 전광판 · 빔프로젝터 전문 기업
                    </p>
                    <h1>
                        공간에 맞는 영상,<br />
                        <span>현장에 필요한 기술</span>
                    </h1>
                    <p className="main-visual-description">
                        기획부터 설계, 시공, 사후관리까지<br />
                        최적의 솔루션으로 최고의 가치를 제공합니다.
                    </p>
                    <div className="main-visual-buttons">
                        <Link to="/portfolio" className="main-button primary">
                            시공사례 보기 <span>→</span>
                        </Link>
                        <Link to="/inquiry" className="main-button secondary">
                            견적문의 하기 <span>→</span>
                        </Link>
                    </div>
                </div>

                <div className="main-visual-features">
                    {features.map((feature) => (
                        <div className="main-feature" key={feature.number}>
                            <div className="main-feature-icon">
                                <i className={`mdi ${feature.icon}`}></i>
                            </div>
                            <div className="main-feature-info">
                                <span className="main-feature-number">{feature.number}</span>
                                <strong>{feature.title}</strong>
                                <p>{feature.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MainVisual;